function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { ExportStatusType } from 'api/async-export';
import { HttpClient } from 'api/http-client';
const BASE_URL = '/custom-reports';
class CustomReportsApiClient extends HttpClient {
    getFormulaFieldsFeatureFlag() {
        return this.get(`${BASE_URL}/enable`);
    }
    constructor(...args){
        super(...args), _define_property(this, "getFields", async (sourceType, templateIds)=>{
            const params = new URLSearchParams({
                source: sourceType
            });
            if (templateIds != null && templateIds.length > 0) {
                params.append('templateIds', templateIds.toString());
            }
            return this.get(`${BASE_URL}/get-fields?${params.toString()}`);
        }), _define_property(this, "getNumberFields", async (sourceType, templateIds)=>{
            const params = new URLSearchParams({
                source: sourceType
            });
            if (templateIds != null && templateIds.length > 0) {
                params.append('templateIds', templateIds.toString());
            }
            return this.get(`${BASE_URL}/formula-builder-fields?${params.toString()}`);
        }), _define_property(this, "getPivotFields", async (sourceType, templateIds)=>{
            const params = new URLSearchParams({
                source: sourceType
            });
            if (templateIds != null && templateIds.length > 0) {
                params.append('templateIds', templateIds.toString());
            }
            return this.get(`${BASE_URL}/get-pivot-fields?${params.toString()}`);
        }), _define_property(this, "getPivotDefinition", async (pivotReportRequest)=>this.post(`${BASE_URL}/get-pivot-definition`, pivotReportRequest)), _define_property(this, "getPivotData", async (pivotReportRequest)=>this.post(`${BASE_URL}/get-pivot-data`, pivotReportRequest)), _define_property(this, "getTabularGroups", async (tabularReportRequest)=>this.post(`${BASE_URL}/get-tabular-groups`, tabularReportRequest)), _define_property(this, "getTabularData", async (tabularReportRequest)=>this.post(`${BASE_URL}/get-tabular-data`, tabularReportRequest)), _define_property(this, "getRowTotalReport", async (customReportPayload)=>this.post(`${BASE_URL}/get-row-count`, customReportPayload)), _define_property(this, "getPivotColumnTotal", async (customReportPayload)=>this.post(`${BASE_URL}/pivot-column-total`, customReportPayload)), _define_property(this, "getAllCustomReports", async ()=>this.get(`${BASE_URL}/get-all-custom-reports`)), _define_property(this, "getPaginatedCustomReports", async (params)=>{
            const searchParams = new URLSearchParams();
            if (params.search != null && params.search !== '') {
                searchParams.set('search', params.search);
            }
            searchParams.set('limit', String(params.limit));
            searchParams.set('offset', String(params.offset));
            if (params.orderBy != null && params.orderBy !== '' && params.sortOrder != null) {
                searchParams.set('sort', `${params.orderBy}.${params.sortOrder}`);
            }
            const query = searchParams.toString();
            return this.get(`${BASE_URL}/paginated${query ? `?${query}` : ''}`);
        }), _define_property(this, "getCustomReport", async (customReportId)=>this.get(`${BASE_URL}/get-custom-report/${customReportId}`)), _define_property(this, "createCustomReport", async (customReportPayload)=>this.post(`${BASE_URL}/create-custom-reports`, customReportPayload)), _define_property(this, "saveCustomReport", async (customReportPayload)=>this.post(`${BASE_URL}/save`, customReportPayload)), _define_property(this, "deleteCustomReport", async (widgetId)=>this.delete(`${BASE_URL}/delete/${widgetId}`)), _define_property(this, "getConditionalHighlight", async (customReportPayload)=>this.post(`${BASE_URL}/conditional-highlighting`, customReportPayload)), _define_property(this, "getExportData", async (request)=>{
            const exportPayload = {
                statusType: ExportStatusType.CustomReportExport,
                statusMeta: {
                    request
                }
            };
            return this.post('async/status', exportPayload);
        }), _define_property(this, "getFormTemplates", async ()=>this.get(`${BASE_URL}/get-form-templates`)), // todo remove these methods later
        _define_property(this, "getTabularExportData", async (exportRequest)=>this.post(`${BASE_URL}/tabular/export`, exportRequest)), _define_property(this, "getPivotExportData", async (exportRequest)=>this.post(`${BASE_URL}/pivot/export`, exportRequest));
    }
}
export const CustomReportsApi = new CustomReportsApiClient();
